import { Box, Text, Button } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { routes } from "config/paths";
import AIProgressWidget from "../AITasks/AIProgressWidget";

export default function AIReviewRelaxPanel({ task }) {
  const navigate = useNavigate();
  return (
    <Box>
      <Text mt={4}>
        We are generating answers for your selections. Track progress in the disclosure builder status dashboard.
        Answers will be added as drafts within the activity stream for each requirement. These will not be automatically
        applied.
      </Text>

      <Button
        mt={4}
        variant="primary"
        onClick={() => {
          navigate(`${routes.issbRequirements}?rtab=1`);
        }}
      >
        OK, I'm done here
      </Button>
    </Box>
  );
}
